
<div class="footer-item" *ngFor="let item of footerItems;">
    <div class="icon-wrapper">
        <img [ngClass]="item.classes" src="{{item.icon}}" alt="">
    </div>
    <div class="item-name">{{item.name}}</div>
</div>
